/** A check mark in a circle that draws itself once (stroke animation; static under prefers-reduced-motion). */
export function SuccessCheck({ size = 40 }: { size?: number }) {
  return (
    <svg className="success-check" width={size} height={size} viewBox="0 0 40 40" aria-hidden="true" focusable="false">
      <circle className="success-check-ring" cx="20" cy="20" r="17" pathLength={1} />
      <path className="success-check-mark" d="M12.5 20.5l5 5 10-11" pathLength={1} />
    </svg>
  );
}
